import Box from "pages/_components/Box";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import Text from "pages/_components/Text";
import React from "react";

// Dashboard Tour steps
// eslint-disable-next-line
export const dashboardTourSteps = [
    {
        target: "#appDefaultContainer",
        title: <I18n id="dashboardTour.title.step1" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.step1" />,
        placement: "center",
    },
    {
        target: "#toggleSidebar",
        title: <I18n id="dashboardTour.title.step2" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.step2" />,
        placement: "bottom",
    },
    {
        target: "#menuTransfers",
        title: <I18n id="dashboardTour.title.step3" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.step3" />,
        placement: "bottom",
    },
    {
        target: "#eyeButton",
        title: <I18n id="dashboardTour.title.step4" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.step4" />,
        placement: "bottom",
    },
    {
        target: "#notificationButton",
        title: <I18n id="dashboardTour.title.step5" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.step5" />,
        placement: "bottom",
    },
    {
        target: "#userPopup",
        title: <I18n id="dashboardTour.title.step6" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.step6" />,
        placement: "bottom",
    },
    {
        target: "#editDashboardBtn",
        title: <I18n id="dashboardTour.title.step7" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.step7" />,
        placement: "auto",
    },
    {
        target: "#appDefaultContainer",
        title: <I18n id="dashboardTour.title.step8" />,
        content: (
            <Box>
                <Image src="images/icons/contextualMenu.svg" className="mb-5" />
                <Text component="p" className="m-0" labelKey="dashboardTour.text.step8" />
            </Box>
        ),

        placement: "center",
    },
    {
        target: "#shortCuts",
        title: <I18n id="dashboardTour.title.step10" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.step10" />,
        placement: "bottom",
    },
];
// eslint-disable-next-line
export const corporateDashboardTourSteps = [
    {
        target: "#appDefaultContainer",
        title: <I18n id="dashboardTour.title.corporateStep1" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.corporateStep1" />,
        placement: "center",
    },
    {
        target: "#toggleSidebar",
        title: <I18n id="dashboardTour.title.corporateStep2" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.corporateStep2" />,
        placement: "bottom",
    },
    {
        target: "#menuTransfers",
        title: <I18n id="dashboardTour.title.corporateStep3" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.corporateStep3" />,
        placement: "bottom",
    },
    {
        target: "#transactionHistory",
        title: <I18n id="dashboardTour.title.corporateStep5" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.corporateStep5" />,
        placement: "bottom",
    },
    {
        target: "#pendingOperations",
        title: <I18n id="dashboardTour.title.corporateStep6" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.corporateStep6" />,
        placement: "bottom",
    },
    {
        target: "#environmentTag",
        title: <I18n id="dashboardTour.title.corporateStep7" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.corporateStep7" />,
        placement: "auto",
    },
    {
        target: "#notificationButton",
        title: <I18n id="dashboardTour.title.corporateStep8" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.corporateStep8" />,
        placement: "bottom",
    },
    {
        target: "#appDefaultContainer",
        title: <I18n id="dashboardTour.title.corporateStep9" />,
        content: (
            <Box>
                <Image src="images/icons/contextualMenu.svg" className="mb-5" />
                <Text component="p" className="m-0" labelKey="dashboardTour.text.corporateStep9" />
            </Box>
        ),

        placement: "center",
    },
    {
        target: "#editDashboardBtn",
        title: <I18n id="dashboardTour.title.corporateStep10" />,
        content: <Text component="p" className="m-0" labelKey="dashboardTour.text.corporateStep10" />,
        placement: "bottom",
    },
];
